import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import {
  useDispatch,
} from 'react-redux';
import {
  toast,
} from 'react-toastify';
import {
  useParams,
  useNavigate,
} from 'react-router-dom';
import MobileDetect from 'mobile-detect';
import * as Yup from 'yup';

import {
  coreActions,
} from '@gymcloud/core';

import config from 'web-config';
import {
  NamespaceLogo,
  PasswordField,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6)
    .required('Password is required'),
  password_confirmation: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password'), null], 'Passwords do not match'),
});

const ResetPassword = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onSubmit = (values: any, actions: any) => {
    dispatch(
      coreActions.confirmPasswordRequest({
        payload: {
          ...values,
          reset_password_token: params.token,
        },
        callbacks: {
          ...actions,
          onSuccess: () => {
            toast.success(
              'Your password was updated',
            );
            const md = new MobileDetect(window.navigator.userAgent);
            navigate(md.mobile() ? '/get_app' : '/login');
          },
        },
      }),
    );
  };

  return (
    <S.PageWrap>
      <NamespaceLogo />
      <S.FormWrap>
        <S.FormTitle>
          Reset Password
        </S.FormTitle>
        <Flex column width="100%" align="center" margin="-10px 0 25px 0">
          <Text>
            Enter and confirm your new password below
          </Text>
        </Flex>
        <Formik
          initialValues={{
            password: '',
            password_confirmation: '',
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {(formikProps) => (
            <S.Form
              column
              width="100%"
              spacing={15}
              onSubmit={formikProps.handleSubmit}
            >
              <Field
                name="password"
                label="New Password"
                component={PasswordField}
              />
              <Field
                name="password_confirmation"
                label="Confirm New Password"
                component={PasswordField}
              />

              {formikProps.status?.reset_password_token && (
                <S.Error>Reset password token has expired</S.Error>
              )}

              <Flex
                width="100%"
                justify="space-between"
                align="center"
              >
                <S.BackLink to="/login">
                  Cancel
                </S.BackLink>
                <S.SubmitButton
                  isLoading={formikProps.isSubmitting}
                  style={{ width: '200px' }}
                >
                  Change Password
                </S.SubmitButton>
              </Flex>
            </S.Form>
          )}
        </Formik>
      </S.FormWrap>
      <S.TextCenter>
        <a href={`${config.urls.landing}/contact`}>Contact us</a>
      </S.TextCenter>
    </S.PageWrap>
  );
};

export default ResetPassword;
